import {Component, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {EventManagerService} from "@cybfed/core/services/event-manager.service";
import {StorageService} from "@cybfed/core/services/storage.service";
import {EventBarComponent} from "@cybfed/shared/widget/event-bar/event-bar.component";
import {isPlatformBrowser, NgForOf, NgIf} from "@angular/common";
import {appConstants} from "@cybfed/constants";
import {SocketMainService} from "@cybfed/core/services/socket/socket-main-service";
import {MeService} from "@cybfed/core/services/me.service";
import {RoomService} from "@cybfed/core/services/room.service";
import {CookieService} from "ngx-cookie-service";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {ParticipateService} from "@cybfed/core/services/participate.service";
import {DisputeService} from "@cybfed/core/services/dispute.service";
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {TeamsService} from "@cybfed/core/services/teams.service";
import {WindowRef} from "@cybfed/core/helpers/windowRef.service";
import {customSetTimeout} from "@cybfed/core/helpers/overrided-timers";
import {HttpService} from "@cybfed/core/services/http.service";
import {OrderService} from "@cybfed/core/services/marketplace/order.service";
import {environment} from "@shared-environments/environment";
import {
    ChatRoomOptionsModalComponent
} from "@cybfed/shared/components/chat-room-options-modal/chat-room-options-modal.component";
import {ChatWidgetComponent} from "@cybfed/shared/components/chat-widget/chat-widget.component";
import {VoteFormComponent} from "@cybfed/shared/components/vote-form/vote-form.component";
import {SocketConnect} from "@cybfed/core/services/socket/socket-connect";
import {EventService} from "@cybfed/core/store/event.service";


@Component({
    selector: 'app-main',
    standalone: true,
    imports: [
        RouterOutlet,
        NgIf,
        EventBarComponent,
        ChatRoomOptionsModalComponent,
        ChatWidgetComponent,
        NgForOf,
        VoteFormComponent,
    ],
    providers: [
        {
            provide: SocketMainService,
            useFactory: (
                platformId: Object,
                socket: SocketConnect,
                eventManager: EventManagerService,
                eventService: EventService
            ) => {
                if (isPlatformBrowser(platformId)) {
                    return new SocketMainService(socket, platformId, eventManager, eventService);
                }
                return null; // Avoid initializing on the server
            },
            deps: [PLATFORM_ID, SocketConnect, EventManagerService, EventService]
        },
        {
            provide: SocketConnect,
            useFactory: (platformId: Object) => {
                if (isPlatformBrowser(platformId)) {
                    return new SocketConnect(platformId); // Initialize only in the browser
                }
                return null; // Avoid initializing on the server
            },
            deps: [PLATFORM_ID]
        },
        MeService,
        CookieService,
        PopupHelperService,
        ParticipateService,
        DisputeService,
        TranslateService,
        FormBuilder,
        RoomService,
        HttpService,
        TeamsService,
        WindowRef,
        OrderService
    ],
    templateUrl: './main.component.html'
})
export class MainComponent implements OnInit {

    @ViewChild('modal') modal: any;
    @ViewChild('menuIndicator') menuIndicator: any;
    @ViewChild('createTeamModal') createTeamModal: any;

    showMobileMenu = true;
    ticketsCount = 0;
    totalTickets = 0;
    breadCrumbItems: any;
    rules: any;
    profileData:any;
    maxChatsShow = 3;
    cookiePrefix = '43eTT';
    cookieSuffix = 'dd456'
    activeRoomsInfo: any = [];
    showScroll = ''
    showMobile:any;
    activeTaskCount = 0;

    rendered = false;
    authUser:any;
    activeEvents:any;
    openChatInEventTabIds: any = [];
    openByPayByTeamLeaderInvite: boolean = false
    size: any;
    teamMembersCount: any
    payByTeamLeader: boolean = false

    @ViewChild('NotificationModal') NotificationModal: any
    types: any = appConstants.NOTIFICATIONTYPES;
    opened = false;
    message = '';
    public modalNotification: any
    public eventDescription: any

    public videoAdvertisement: any = [];

    public showAdvertisement: boolean = false;
    public createTeamForm: any;
    public teamImage: any;
    public rerender = true;
    public showTeamImageRequired: boolean = false
    public buttonLoad: boolean = false
    private createTeamData: any;
    loading = false;

    constructor(private socketService: SocketMainService,
                private meService: MeService,
                private roomService: RoomService,
                private cookieService: CookieService,
                private eventManagerService: EventManagerService,
                private popupHelperService: PopupHelperService,
                private router: Router,
                private participantService:ParticipateService,
                private disputeService: DisputeService,
                private translateService:TranslateService,
                private formBuilder: FormBuilder,
                private teamsService: TeamsService,
                @Inject(PLATFORM_ID) private platformId: any,
                private windowRef: WindowRef,
    ) {
        this.authUser = StorageService.getJsonItem(StorageService.statics.currentUser);
        if(this.authUser){
            this.setChatWidgetListeners();
        }
        if(isPlatformBrowser(this.platformId)){
            var prevScrollpos = this.windowRef.nativeWindow.pageYOffset;
            window.onscroll = () => {
                var currentScrollPos = window.pageYOffset;
                if (prevScrollpos > currentScrollPos) {
                    this.showScroll = 'show-menu'
                } else {
                    this.showScroll = 'hide-menu'
                }
                prevScrollpos = currentScrollPos;
            }
        }
    }

    ngOnInit(): void {
        this.eventManagerService.changeUserEmitter.subscribe((data: any) => {
            this.profileData = {...this.profileData,  ...data}
        })

        this.eventManagerService.rerenderEvent.subscribe(()=>{
            this.rerender = false;
            customSetTimeout(() =>{
                this.rerender = true;
            })
        })
        this.showMobileMenu = this.router.url.indexOf('/messages/') === -1;
        this.router.events.subscribe(()=>{
            this.showMobileMenu = this.router.url.indexOf('/messages/') === -1;
        })

        if(this.authUser) {
            if(this.router.url.indexOf('/auth-provider') === -1){
                let redirectUrl = StorageService.getJsonItem(StorageService.statics.lastPage);
                if(redirectUrl){
                    StorageService.removeItem(StorageService.statics.lastPage);
                    this.router.navigate([redirectUrl.url], { queryParams:redirectUrl.queryParams });
                }
            }
            this.eventManagerService.updateHomePage.subscribe(()=>{
                this.getProfileData();
                this.rendered = true;
            })

            this.getProfileData();

            // @ts-ignore
            this.getInitialInfo();
            this.socketService.listenToEventWithCallback(appConstants.ACTIONTYPES.DELETE, appConstants.EVENTTYPES.USER,(data: any) =>{
                if (data.chatRoomId){
                    this.eventManagerService.deleteChatRoom(data.chatRoomId)
                    if(this.activeRoomsInfo && this.activeRoomsInfo.length > 0){
                        let chatRoomIndex = this.activeRoomsInfo.map(function (e:any) {
                            return e.room?._id;
                        }).indexOf(data.chatRoomId)
                        if(chatRoomIndex >= 0){
                            this.closeRoom(chatRoomIndex)
                        }
                    }
                }

            });

            this.eventManagerService.closeOpenChatRoomsEmitter.subscribe(()=>{
                this.activeRoomsInfo = []
                StorageService.removeItem(StorageService.statics.chatActiveRoomIds)
            })
            this.eventManagerService.sendOpenChatIdEmitter.subscribe((roomId: string)=>{
                let index1 = this.openChatInEventTabIds.indexOf(roomId)
                if(index1 === -1){
                    this.openChatInEventTabIds.push(roomId)
                }
                let index = this.activeRoomsInfo.findIndex((x: any)=> x.roomId?x.roomId === roomId:x.room._id === roomId)
                if(index >= 0){
                    this.closeRoom(index)
                }
            })

            this.eventManagerService.sendCloseChatIdEmitter.subscribe((roomId: string) =>{
                let index = this.openChatInEventTabIds.indexOf(roomId)
                if(index >= 0){
                    this.openChatInEventTabIds.splice(index, 1);
                }
            })
        }
        this.eventManagerService.openNotificationModalEmitter.subscribe((notification:any)=>{
            this.modalNotification = notification
            setTimeout(() => {
                this.NotificationModal && this.NotificationModal.show()
            }, 300)

        })


        this.maxChatsShow = 2;
        if(this.authUser){
            this.createTeamForm = this.formBuilder.group({
                name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(20)]),
                gameId: new FormControl('', [Validators.required]),
                description: new FormControl('', []),
                logoId: new FormControl('', []),
                // privateTeam: new FormControl(false, [])
            });
            this.reorderRooms();

            this.eventManagerService.chooseInParticipatedTeamEmitter.subscribe((data: any) =>{
                let currenUrl = this.router.url
                let navigationUrl
                switch (data.forTable) {
                    case 'challenge':
                        navigationUrl = '/tournaments/challenge/' + data.forId
                        break;
                    case 'tournament':
                        navigationUrl = '/tournaments/' + data.forId
                        break;
                }

                if(navigationUrl && navigationUrl === currenUrl){
                    this.eventManagerService.scrollToTeamSection()
                }else {
                    this.router.navigate( [navigationUrl], {fragment: 'scrollToTeamSection'} )
                }
            })
            this.eventManagerService.saveNewTeamEmitter.subscribe((data: any) =>{
                this.createTeamData = data
                this.openPopup()
            })
        }
        this.eventManagerService.loaderShowEmitter.subscribe(() => {
            this.loading = true
        })
        this.eventManagerService.loaderHideEmitter.subscribe(() => {
            this.loading = false
        })
    }

    ngOnDestroy() {
        //this.socketService.unJoinRoom(appConstants.EVENTTYPES.USER, this.authUser.userId)
    }

    getProfileData(){
        this.meService.getProfile().subscribe((data: any)=>{
            this.eventManagerService.hidePublisherToAccountLoading()
            if (!data.hasError) {
                let cookie = this.cookieService.get('getFaster');
                if(!cookie){
                    this.setCookie('getFaster',this.cookiePrefix + data.data.account._id + this.cookieSuffix)
                } else {
                    cookie = cookie.slice(5, cookie.length - 5);
                    if(cookie !== data.data.account._id){
                        this.meService.checkUserExperience(
                            {
                                token: this.cookieService.get('getFaster')
                            }
                        ).subscribe()
                        this.setCookie('getFaster',this.cookiePrefix + data.data.account._id + this.cookieSuffix);
                    }
                }
                this.totalTickets = data.data?.account?.tickets;
                StorageService.setJsonItem(StorageService.statics.profileData, data.data?.account)
                StorageService.setItem(StorageService.statics.currency, data.data?.account.currency);
                if(data.data?.account){
                    this.eventManagerService.profileDataSated()
                    this.profileData = StorageService.getJsonItem(StorageService.statics.profileData)
                    StorageService.setItem(StorageService.statics.currency, this.profileData.currency);
                }

                this.eventManagerService.changeUser(data.data.account)
            } else {
                this.popupHelperService.printError({text:data.errorMessages[0].msg});
            }
        })
    }
    getInitialInfo(){
        this.meService.getInitialInfo().subscribe((data)=>{
            if(!data.hasError){
                StorageService.setJsonItem(StorageService.statics.initialInfo, data.data.initialInfo)
                StorageService.setItem(StorageService.statics.ticketPrice, data.data.ticketPrice)
                this.activeEvents = data.data.initialInfo.activeEvents;
                this.eventManagerService.initialInfo(data.data.initialInfo)
                this.eventManagerService.tempTeamInvitesCount(data.data.pendingTemporaryTeamInviteCount)
                this.eventManagerService.teamInvitesCount(data.data.pendingTeamInviteCount)
                if(data.data.showWithPopupNotification){
                    this.eventManagerService.openNotificationModal(data.data.showWithPopupNotification)
                }
                //this.activeTaskCount = data.data.notDoneTasksCount;
                this.eventManagerService.updateTasksCount.emit(data.data.notDoneTasksCount);
                this.eventManagerService.updateTasksCount.subscribe((data:any) => {
                    if(data < 0){
                        this.activeTaskCount--;
                    }
                })
                this.getActiveChatRooms()
            }
        })
    }



    closeRoom(index:number){
        this.activeRoomsInfo.splice(index,1);
        let activeRoomIds = StorageService.getJsonItem(StorageService.statics.chatActiveRoomIds) || []
        activeRoomIds.splice(index,1);
        StorageService.setJsonItem(StorageService.statics.chatActiveRoomIds, activeRoomIds)
    }

    openNewRoom(roomInfo: any){
        this.hideMenu();
        let openIndex = this.openChatInEventTabIds.indexOf(roomInfo.roomId?roomInfo.roomId:roomInfo.room?._id)
        if(!this.router.url.includes("messages") && openIndex === -1) {
            let activeRoomIds = StorageService.getJsonItem(StorageService.statics.chatActiveRoomIds) || []
            for (let i = 0; i < this.activeRoomsInfo.length; i++) {
                if (this.activeRoomsInfo[i].roomId) {
                    if (roomInfo.roomId && this.activeRoomsInfo[i].roomId === roomInfo.roomId) {
                        if (roomInfo.openMessages) {
                            this.activeRoomsInfo[i].openMessages = true
                        }
                        return
                    } else if (roomInfo.room && this.activeRoomsInfo[i].roomId === roomInfo.room._id) {
                        if (roomInfo.openMessages) {
                            this.activeRoomsInfo[i].openMessages = true
                        }
                        return
                    }
                } else if (this.activeRoomsInfo[i].room) {
                    if (roomInfo.roomId && this.activeRoomsInfo[i].room._id === roomInfo.roomId) {
                        if (roomInfo.openMessages) {
                            this.activeRoomsInfo[i].openMessages = true
                        }
                        return
                    } else if (roomInfo.room && this.activeRoomsInfo[i].room._id === roomInfo.room._id) {
                        if (roomInfo.openMessages) {
                            this.activeRoomsInfo[i].openMessages = true
                        }
                        return
                    }
                }
            }
            if(this.maxChatsShow > this.activeRoomsInfo.length){
                this.activeRoomsInfo.push(roomInfo)
                if (roomInfo.roomId) {
                    activeRoomIds.push(roomInfo.roomId)
                } else if (roomInfo.room) {
                    activeRoomIds.push(roomInfo.room._id)
                }
            }

            StorageService.setJsonItem(StorageService.statics.chatActiveRoomIds, activeRoomIds)
        }
    }

    reorderRooms(){
        while(this.activeRoomsInfo.length>this.maxChatsShow){
            this.activeRoomsInfo.splice(0,1);
        }
    }

    setChatWidgetListeners(){
        this.eventManagerService.openChatWidgetEmitter.subscribe((data: any)=>{
            if(data.room){
                this.openNewRoom(data)
            }else if(data.newMessage){
                this.openNewRoom({roomId:data.newMessage.roomId})
            }
        })
    }
    getActiveChatRooms(){
        let activeRoomIds = StorageService.getJsonItem(StorageService.statics.chatActiveRoomIds)||[]
        if(activeRoomIds.length > 0){
            this.roomService.getItems({},{'_ids[]': activeRoomIds}).subscribe((data: any)=>{
                if(!data.hasError){
                    for (let i = 0; i < data.data.data.length; i++){
                        this.activeRoomsInfo[i] = {room: data.data.data[i]}
                    }
                }
            })
        }
    }

    hideMenu(){
        this.showScroll = 'hide-menu'
    }

    openNotifyByTelegramModal(){
        this.meService.notifyByTelegram({}).subscribe((data: any)=>{
            if(!data.hasError){
                if(data.data.code && isPlatformBrowser(this.platformId)){
                    let telegramUrl = 'https://t.me'+environment.telegramChannel+'?start=' + data.data.code // cybfed-locale-bot
                    this.windowRef.nativeWindow.open(telegramUrl,'_blank');
                }else {
                    this.popupHelperService.printSuccess()
                }
            }
        })
    }
    // --------------------------------notification logic-------------------------------------------------
    closeNotificationModal(){
        this.meService.closeNotificationModal(this.modalNotification._id).subscribe((data: any)=>{

        })
    }

    subscribe(){
        this.participantService.subscribe(this.modalNotification.metaData.participantId).subscribe((data) => {
            if(data.hasError){
                return this.popupHelperService.printError({text: data.data.errorMessages[0].msg});
            }
            if(data.data.message){
                this.eventManagerService.openTelegramModal();
            }else{
                this.popupHelperService.printSuccess();
            }
            this.NotificationModal.hide();
        })
    }
    setMetadata(data:any){
        this.message = data.target.value;
    }
    skip():void{
        this.opened = false;
        this.NotificationModal.hide();
    }
    openDispute(){
        this.opened = true;
    }
    onSend():void{
        let disputeData = {
            forTable: this.modalNotification.forTable,
            forId: this.modalNotification.forId._id,
            context: this.message,
            accountId: StorageService.getJsonItem(StorageService.statics.currentUser).userId
        }
        this.disputeService.add(disputeData).subscribe((data: any) => {
            if(!data.hasError){
                this.NotificationModal.hide();
                this.popupHelperService.printSuccess('success_open_dispute')
            }else {
                this.popupHelperService.printError({text: data.errorMessages[0].msg})
            }
        });
    }
    pictureNav(){
        // customSetTimeout(()=>{
    }
    ngAfterViewInit(): void {
        this.pictureNav()
    }



    closeMenu(){
        this.eventManagerService.menuTrigger.emit(-2);
    }

    setCookie(name:any, value:any){
        if (environment.enableCookies)
            this.cookieService.set(name,value);
    }


    closeAdv() {
        this.showAdvertisement = false
    }
    openPopup(): void {
        const popupSettings = {
            customClass: {
                container:"z-index-9999",
                popup: "bg-000 w-15",
                confirmButton: "pink-button-imp",
                htmlContainer: "color-white",
            },
            icon: 'question',
            text:  this.translateService.instant('save_team'),
            confirmButtonText: this.translateService.instant('yes'),
        }
        this.popupHelperService.printQuestion(popupSettings, '', this.openSaveteamModal, this)
    }
    openSaveteamModal(){
        this.createTeamForm.controls["gameId"].patchValue(this.createTeamData.gameId)
        this.createTeamModal.show()
    }
    setImage(data:any){
        this.teamImage = data[0]
        this.showTeamImageRequired = false
        this.createTeamForm.controls["logoId"].patchValue(this.teamImage.id)
    }
    createTeam(){
        this.buttonLoad = true
        if (this.createTeamForm.invalid) {
            for (const key in this.createTeamForm.controls) {
                if (this.createTeamForm.controls[key].untouched && !this.createTeamForm.controls[key].value) {
                    this.createTeamForm.controls[key].markAsTouched();
                    this.createTeamForm.controls[key].setValue(1);
                    this.createTeamForm.controls[key].setValue('');
                }
            }
            this.buttonLoad = false
            return;
        }
        if (!this.teamImage) {
            this.showTeamImageRequired = true
            this.buttonLoad = false
            return
        }
        let teamData = this.createTeamForm.value;
        teamData.accounts =[]
        for (let i = 0; i< this.createTeamData.team.accounts.length; i++){
            teamData.accounts.push(this.createTeamData.team.accounts[i].accountId)
        }
        this.teamsService.add(teamData).subscribe((data: any)=>{
            if(!data.hasError){
                this.popupHelperService.printSuccess()
                this.createTeamModal.hide()
            }else {
                this.popupHelperService.printError({text: data.errorMessages[0].msg})
            }
            this.buttonLoad = false
        })
    }
    verificate() {
        this.profileData = StorageService.getJsonItem(StorageService.statics.profileData)
        if(!this.profileData?.email){
            this.eventManagerService.triggerEmailVerifyModal.emit();
        }
    }
    ngAfterContentInit() {}

    onSubscribeClick(event: Event): void {
    }


}
